// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"f15bbce1","419":"c9ebcf4f","563":"87b3e757","769":"91b1e438"}[chunkId] + ".chunk.js";
};